import React from 'react'
import { Router, Route, IndexRoute } from 'react-router'
import * as firebase from 'firebase'
import Wrap from './View/Wrap'
import NEWS from './View/News'
import Conversation from './View/Conversation'
import Dictionary from './View/Dictionary'
import UserProfile from './Component/UserProfile'
import Removed from './Component/Removed'
import NoMatch from './View/404'

const config = {
  apiKey: "AIzaSyAqF6Qb5txh3zF0YkIUmAp3Jn7s3mY_65o",
  authDomain: "jreact-89e11.firebaseapp.com",
  databaseURL: "https://jreact-89e11.firebaseio.com",
  projectId: "jreact-89e11",
  storageBucket: "jreact-89e11.appspot.com",
  messagingSenderId: "106735469022"
};
firebase.initializeApp(config);


const JRouter = (props) => (
  <Router {...props}>
   <Route path="/" component={Wrap} >
    <IndexRoute component={Conversation}/>
    <Route path="/Conversation" component={Conversation}/>
    <Route path="/News" component={NEWS}/>
    <Route path="/Dictionary" component={Dictionary} />
    <Route path="/UserProfile" component={UserProfile} />
    <Route path="/Removed" component={Removed} />
    <Route path="*" component={NoMatch} />
   </Route>
  </Router>
)

export default JRouter



// WEBPACK FOOTER //
// ./src/JRouter.js